import { render, staticRenderFns } from "./CombinationsTotalWidth.vue?vue&type=template&id=2a7067d5&scoped=true"
import script from "./CombinationsTotalWidth.vue?vue&type=script&lang=ts"
export * from "./CombinationsTotalWidth.vue?vue&type=script&lang=ts"
import style0 from "./CombinationsTotalWidth.vue?vue&type=style&index=0&id=2a7067d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7067d5",
  null
  
)

export default component.exports